import { createContext, useContext, useState, useCallback } from 'react';

const ActiveProfileContext = createContext(null);

const STORAGE_KEY = 'agentdash_active_profile';

export function ActiveProfileProvider({ children }) {
  const [activeProfileId, setActiveProfileId] = useState(() => {
    return localStorage.getItem(STORAGE_KEY) || null;
  });

  const setProfile = useCallback((profileId) => {
    setActiveProfileId(profileId || null);
    if (profileId) {
      localStorage.setItem(STORAGE_KEY, profileId);
    } else {
      localStorage.removeItem(STORAGE_KEY);
    }
  }, []);

  return (
    <ActiveProfileContext.Provider value={{ activeProfileId, setActiveProfileId: setProfile }}>
      {children}
    </ActiveProfileContext.Provider>
  );
}

export function useActiveProfile() {
  const ctx = useContext(ActiveProfileContext);
  if (!ctx) throw new Error('useActiveProfile must be inside ActiveProfileProvider');
  return ctx;
}
